import Header from '../components/header'
import { graphql } from 'gatsby'
import Footer from '../components/footer'
import { Layout, Menu } from 'antd';
import React, { Component } from "react";
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"
import { Link } from "gatsby";
import '../css/rahul-styles.css'
import { Helmet } from "react-helmet";
import {GiHamburgerMenu} from 'react-icons/gi'
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import ReactGA from 'react-ga'
import PopupForm from '../components/popupForm'

let selectedCategoryName = "All Blogs"

class BlogListing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      blogData : this.props.data.allWordpressWpBlog.edges,
      collapsed: false,
      time: 900000000
    }
  }

componentDidMount(){

}

toggle = () => {
  this.setState({
    collapsed: !this.state.collapsed,
  })
}

filterCategory(i){
  this.setState({
    collapsed: !this.state.collapsed,
  })
  selectedCategoryName = i === "All" ? 'All Blogs' : ReactHtmlParser(this.props.data.allWordpressWpBlogCategories.edges.find(x => x.node.wordpress_id == i).node.name)
  if(i=="All"){
    this.setState({blogData:this.props.data.allWordpressWpBlog.edges})
  }
  else{
    var filteredRes=[]
    this.props.data.allWordpressWpBlog.edges.forEach((element) => 
   {
    let filterGroupActivity = element.node.blog_categories.filter((value) => {
      return value === i;
    });
    if(filterGroupActivity== i)
    filteredRes.push(element)
   
   })

   
   this.setState({blogData:filteredRes})
  }
}

handlePopupWindow = () => {
  this.setState({ time: Math.random() })
}

  
  render(){
  const { Sider } = Layout;
  return (
    
    <div>   
      <Helmet>
        <title>
          Everything you need to know about studying abroad | The WorldGrad
        </title>
        <meta
          name="description"
          content="Get answers to all your study abroad questions on topics like  like, program options to choose from, pros and cons of different countries, student visa application process, how to finance your overseas education, most value for money universities, entry requirement to get into a good university and much more in The WorldGrad study resources section."/>
        <meta
          name="keywords"
          content="study abroad, study overseas, educations courses, student visas, universities"/>
        <link rel="icon" href="https://res.cloudinary.com/worldgrad/image/upload/v1612961357/worldgrad/twg_favicon_ymgrbw.png" />
      </Helmet>
      <Header />

      { /* Main Code */}

      <div className="container-fluid" style={{ overflowX: "hidden" }}>
      <PopupForm time={this.state.time} />
        <div className="col-12">
          <button 
            className="btn fixed-enquire-button" 
            onClick={ () => {
              this.handlePopupWindow()
            }}
          >
            Enquire
          </button>
        </div>
        { /* Start of top row */}
        <div className="container p-0">
          <div className="row top-row-blog-listing">
            <div className="col-6 col-lg-4 laptop-img-container mb-3">
              <img className="img-fluid blog-listing-images " src="https://media.publit.io/file/TheWorldgrad/5StudyResources/banner11_w2hygb.jpg" alt="" />

              {/* <img className="img-fluid" src={blogImg1} alt="" style={{borderRadius:"15px",height:"240px"}}/> */}
            </div>
            <div className="col-3 col-lg-2">
              <img className=" blog-listing-images" src="https://media.publit.io/file/TheWorldgrad/5StudyResources/banner22_qka2n9.jpg" alt="" style={{borderRadius:"15px"}}/>
            </div>
            <div className="col-3 col-lg-2">
              <img className="img-fluid blog-listing-images" src="https://media.publit.io/file/TheWorldgrad/5StudyResources/banner33_qbhvh6.jpg" style={{borderRadius:"15px"}}/>
            </div>
            <div className="col-lg-4 m-auto d-flex align-items-center">
              <div>
                <h1 className=""> The WorldGrad Blog and Resources </h1>
                <p className="blog-listing-top-row-text m-0" > Everything you need to know about studying abroad in one place </p>
              </div>
            </div>
          </div>
        </div>
        { /* End of top row */}

        { /* Start of bottom row */}
        <div className="container-fluid bottom-row-blog-listing-container">
          <div className="row bottom-row-blog-listing">
            <div className="card all-blog-main-card w-100">
              <div className="container-fluid card-with-side-menu">
                <div className="row">
                  {/* <div className="col-10">
                    <div className="row" style={{ marginTop: "60px" }}>
                      <div className="col-6 blog-listing-sub-heading">All Blogs</div>
                      <div className="col-6 text-right blog-listing-sub-heading">
                        <div className="dropdown">
                          <button className="btn btn-secondary dropdown-toggle blog-listing-dropdown" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                            Sort By
                          </button>
                          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            <li><a className="dropdown-item" href="#">Action</a></li>
                            <li><a className="dropdown-item" href="#">Another action</a></li>
                            <li><a className="dropdown-item" href="#">Something else here</a></li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-md-4 col-sm-6">
                        <CardReusable
                          image={libraryImg}
                          title=" Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptate, quos. "
                        />
                      </div>
                      <div className="col-md-4 col-sm-6">
                        <CardReusable
                          image={libraryImg}
                          title=" Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptate, quos. "
                        />
                      </div>
                      <div className="col-md-4 col-sm-6">
                        <CardReusable
                          image={libraryImg}
                          title=" Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptate, quos. "
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-2">
                  </div> */}
                  <div className="col blog-listing-sidebar-container">
                    {/* <SideBar /> */}
                    <div className="sidebar-container">
      <Layout>
        <Layout>
          {/* <Header className="site-layout-sub-header-background" style={{ padding: 0 }} /> */}
          <div className="col-md-12">
            <div className="blog-listing-card-sub-heading-container">
              <div className="col-12 blog-listing-sub-heading">
                {selectedCategoryName}
                {/* {ReactHtmlParser(node.name)} */}
                <button 
                  className="blog-listing-trigger-button"
                  onClick={this.toggle} 
                >
                  <GiHamburgerMenu />
                </button>
              </div>
              {/* <div className="col-6 text-right blog-listing-sub-heading">
                <div className="dropdown">
                  <button className="btn btn-secondary dropdown-toggle blog-listing-dropdown" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                    Sort By
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                    <li><a className="dropdown-item" href="#">POPULARITY</a></li>
                    <li><a className="dropdown-item" href="#">RECENTLY POSTED</a></li>
                  </ul>
                </div>
              </div> */}
             
                {/* <CardReusable
                  image={libraryImg}
                  title=" Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptate, quos. "
                /> */}
             
                <div className="blog-listing-masonry-layout">
                <ResponsiveMasonry
                columnsCountBreakPoints={{350: 1, 750: 2, 900: 3}}
            >
                <Masonry>
                {
                  
                    
                    this.state.blogData.map(({node}) => {
                      return(
                        <div className="blog-listing-card-holder">
                        <div className="card shadow main-card-blog-listing mb-3" style={{borderRadius: "18px"}}>
                          {/* {
                            node.featured_media != null ?
                            (
                              <img src={node.featured_media.source_url} className="card-img-top img-fluid blog-listing-card-image" alt="..." />
                            ) : 
                            (
                              <img src={libraryImg} className="card-img-top img-fluid blog-listing-card-image" alt="..." />
                            )
    
                          } */}
                        <Link  to={`/blog-detail/${node.slug}/`}>
                        <div onClick={() => {
                          ReactGA.event({
                            category: "Study Resources",
                            action: "Clicks",
                            label: `${ReactHtmlParser(node.title)}`
                          })
                        }} className="card-body blog-listing-card-body">
                        <a><h5 className="card-title mt-3 blog-listing-card-title blogtitle">{ReactHtmlParser(node.title)} </h5></a>
                        <p className="card-text blog-listing-card-text blogcontent"> {ReactHtmlParser(node.acf.description)} </p>


                         <div className="category-holder">
                           {node.acf.select_category.map((d, index) => 
                             <span className="blog-listing-category"> {d}</span> 
                           )} 
                          </div>
                          
                          <p className="text-muted blog-listing-date-text"> - Posted on {node.acf.posted_date} </p>
                        </div>
                        </Link>
                      </div>
                     </div>
                      )
                    
                    })
                 
               }
               {/* {this.renderData()} */}
                 </Masonry>
            </ResponsiveMasonry>
              </div>
             
             
            </div>
          </div>
        </Layout>
        <Sider
          breakpoint="lg"
          collapsedWidth="0"
          onBreakpoint={broken => {
            if (window.screen.width < 990) {
              this.setState({
                collapsed: true 
              }) 
            } else {
              this.setState({
                collapsed: false
              })
            }
          }}
          onCollapse={(collapsed, type) => {
            console.log(collapsed, type);
          }}
          width='125'
          collapsed={this.state.collapsed}
          trigger={null}
        >
          <div className="logo" />
          <Menu theme="dark" mode="inline" defaultSelectedKeys={['1']}>
            <h5 style={{fontSize: "18px"}}> Categories </h5>
            <Menu.Item key="1" onClick={this.filterCategory.bind(this,"All")}>
                    All
            </Menu.Item>
            {
              this.props.data.allWordpressWpBlogCategories.edges.map(({node}) => {
                return(
                  <Menu.Item key={node.wordpress_id} style={{overflow:"initial"}} onClick={this.filterCategory.bind(this,node.wordpress_id)}>
                    {ReactHtmlParser(node.name)}
                  </Menu.Item>
                )
                
              })
             }
          </Menu>
        </Sider>
      </Layout>
    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>





      </div>
      <Footer />
    </div>
  )
}
}

export default BlogListing;

export const bloglisting = graphql`
  query bloglisting 
    {
      allWordpressWpBlog{
        edges{
          node{
            id
            title
            slug
            blog_categories
            acf{
              description
              posted_date
              select_category
            }
          }
        }
      }
      allWordpressWpBlogCategories{
        edges{
          node{
            id
            name
            wordpress_id
          }
        }
      }
    }
  
`;

// select_category below posted_date